<template>
    <v-layout wrap align-start>
        <v-flex>
            <v-card class="card--flex-toolbar">
                <v-toolbar flat>
                    <v-toolbar-title class="grey--text">Pedidos</v-toolbar-title>
                </v-toolbar>
                <v-container grid-list-md style="max-width: initial; padding: 20px">
                    <v-layout wrap>
                        <v-form>
                            <v-layout wrap>
                                <v-flex xs12 md4>
                                    <v-dialog
                                        ref="dialog"
                                        v-model="modal_desde"
                                        :return-value.sync="filter.desde"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="filter.desde"
                                                label="Desde:"
                                                prepend-icon="event"
                                                readonly
                                                clearable
                                                @click:clear="filter.hasta = null"
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker
                                            v-model="filter.desde"
                                            locale="es-MX"
                                            scrollable
                                        >
                                            <v-spacer/>
                                            <v-btn color="gray" @click="modal_desde = false">
                                                Cancelar
                                            </v-btn>
                                            <v-btn
                                                color="primary"
                                                @click="$refs.dialog.save(filter.desde)"
                                            >
                                                Aceptar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-dialog
                                        ref="dialog2"
                                        v-model="modal_hasta"
                                        :return-value.sync="filter.hasta"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="filter.hasta"
                                                label="Hasta:"
                                                prepend-icon="event"
                                                :disabled="filter.desde === null"
                                                readonly
                                                clearable
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker
                                            v-model="filter.hasta"
                                            :min="filter.desde"
                                            locale="es-MX"
                                            scrollable
                                        >
                                            <v-spacer/>
                                            <v-btn color="gray" @click="modal_hasta = false">
                                                Cancelar
                                            </v-btn>
                                            <v-btn
                                                color="primary"
                                                @click="$refs.dialog2.save(filter.hasta)"
                                            >
                                                Aceptar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-select
                                        v-model="filter.anonimo"
                                        :items="[
                      { value: -1, text: 'Todos' },
                      { value: 0, text: 'Registrados' },
                      { value: 1, text: 'Anónimos' },
                    ]"
                                        menu-props="auto"
                                        label="Tipo de cuenta"
                                        hide-details
                                        prepend-icon="visibility"
                                    />
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-select
                                        v-model="filter.estatus_id"
                                        :items="estatus_list"
                                        menu-props="auto"
                                        label="Estatus del pedido"
                                        hide-details
                                        prepend-icon="flag"
                                    />
                                </v-flex>
                                <!-- <v-flex
                                                        xs12
                                                        md4
                                                >
                                                    <v-select
                                                            v-model="filter.repartidor_id"
                                                            :items="$_todos('nombre_completo').concat(repartidores)"
                                                            item-text="nombre_completo"
                                                            item-value="id"
                                                            label="Repartidor"
                                                            prepend-icon="mdi-truck"
                                                    />
                                                </v-flex> -->
                                <v-flex xs12 md4>
                                    <SearchRepartidoresInput
                                        @selected="filter.repartidor_id = $event"
                                    ></SearchRepartidoresInput>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field
                                        v-model="filter.folio"
                                        label="Folio"
                                        prepend-icon="mdi-book"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <SearchClientesInput
                                        @selected="filter.cliente_id = $event"
                                    ></SearchClientesInput>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <SearchTagsInput
                                        :id="true"
                                        @selected="filter.tag_id = $event"
                                    ></SearchTagsInput>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-layout>
                </v-container>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="blue darken-1"
                        class="white--text"
                        :loading="loading"
                        :disabled="loading"
                        @click="listar"
                    >
                        Buscar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
        <v-flex grow pt-2>
            <v-data-table
                :headers="headers"
                :items="pedidos"
                :options.sync="options"
                class="elevation-1"
                no-data-text="No hay registros disponibles"
                :sort-by="'created_at'"
                :sort-desc="true"
                :loading="loading"
                :server-items-length="pedidosTotal"
                :footer-props="{
          itemsPerPageOptions: $root.OPTIONS_PER_PAGE_DATATABLE,
        }"
                @update:options="listar"
            >
                <template v-slot:item.id="{ item }">
                    {{ $_str_pad_left(item.id) }}
                </template>

                <template v-slot:item.user="{ item }">
                    {{
                        item.anonimo
                            ? item.anonimo_detalles.contacto
                            : item.user.nombre +
                            " " +
                            item.user.apellido_paterno +
                            " " +
                            item.user.apellido_materno
                    }}
                </template>
                <template v-slot:item.anonimo="{ item }">
                    {{ item.anonimo ? "Si" : "No" }}
                </template>
                <template v-slot:item.estatus_id="{ item }">
                    <v-chip :color="item.estatus.color" text-color="white">
                        {{ item.estatus.nombre }}
                    </v-chip>
                </template>
                <template v-slot:item.total="{ item }">
                    {{ $_currency(item.total) }}
                </template>
                <template v-slot:item.pago_pendiente="{ item }">
                    {{ $_currency(item.pago_pendiente) }}
                </template>
                <template v-slot:item.updated_at="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn outlined v-on="on">
                                {{ item.updated_at | timeSleep }}
                            </v-btn>
                        </template>
                        <span>{{ item.updated_at }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:item.recompensa_aplicada="{ item }">
                    <v-chip
                        v-show="!item.anonimo"
                        :color="item.recompensa_aplicada ? 'success' : 'grey'"
                        text-color="white"
                    >
                        {{ item.recompensa_aplicada ? "Aplicada" : "Pendiente" }}
                    </v-chip>
                </template>
                <template v-slot:item.repartidor="{ item }">
                    <template v-if="item.repartidor">
                        {{ item.repartidor.nombre_completo }}
                    </template>
                </template>
                <template v-slot:item.tags="{ item }">
                    <v-chip v-for="(tag, index) in item.tags" :key="tag.name + index">{{
                            tag.name.es
                        }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                small
                                tooltip="aaa"
                                class="mr-2"
                                color="blue lighten-2"
                                v-on="on"
                                @click="
                  pedido_select = item;
                  dialog_change_status = true;
                "
                            >
                                flag
                            </v-icon>
                        </template>
                        <span>Cambiar estatus</span>
                    </v-tooltip>
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                small
                                class="mr-2"
                                v-on="on"
                                @click="
                  $router.push({
                    name: 'pedido-detalles',
                    params: { pedidoId: item.id },
                  })
                "
                            >
                                visibility
                            </v-icon>
                        </template>
                        <span>Ver pedido</span>
                    </v-tooltip>
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                small
                                class="mr-2"
                                color="green"
                                v-text="'mdi-cellphone-message'"
                                v-on="on"
                                @click="
                  dialog_notify_vendedor = true;
                  itemSelectId = item.id;
                "
                            >
                            </v-icon>
                        </template>
                        <span>Notificar a vendedor</span>
                    </v-tooltip>
                    <v-tooltip left v-if="item.estatus.id == 1">
                        <template v-slot:activator="{ on }">
                            <v-icon
                                small
                                class="mr-2"
                                v-on="on"
                                :color="item.repartidor_id ? 'light-blue darken-4' : 'red'"
                                v-text="'mdi-truck'"
                                @click="asignarRepartidor(item)"
                            >
                            </v-icon>
                        </template>
                        <span>{{ item.repartidor_id ? "Cambiar" : "Asignar" }} Repartidor</span>
                    </v-tooltip>
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                small
                                class="mr-2"
                                v-on="on"
                                @click="
                  pedido_select = item;
                  dialog_set_tags = true;
                "
                            >
                                style
                            </v-icon>
                        </template>
                        <span>Asignar Etiquetas</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-flex>

        <v-dialog v-model="dialog_delete" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Cancelar pedido</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="gray darken-1" @click="dialog_delete = false">
                        No
                    </v-btn>
                    <v-btn
                        color="red darken-1"
                        class="white--text"
                        :loading="loading_cancelar"
                        :disabled="loading_cancelar"
                        @click="deleteItem"
                    >
                        Si
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_change_status" max-width="600px">
            <form-change-status
                v-if="dialog_change_status"
                :pedido-id="pedido_select.id"
                :estatus-actual="pedido_select.estatus_id"
                @form:close="dialog_change_status = false"
                @form:save="estatusCambiado"
            />
        </v-dialog>
        <v-dialog v-model="dialog_set_tags" max-width="600px">
            <form-set-tags
                v-if="dialog_set_tags"
                :pedido-id="pedido_select.id"
                :etiquetas-actual="pedido_select.tags"
                @form:close="dialog_set_tags = false"
                @form:save="etiquetasCambiadas"
            />
        </v-dialog>
        <v-dialog v-model="dialog_notify_vendedor" max-width="600px">
            <form-notify-vendedor
                v-if="dialog_notify_vendedor"
                :pedido="editItem"
                @form:close="dialog_notify_vendedor = false"
                @form:save="messageUrl"
            />
        </v-dialog>
        <v-dialog
            v-model="dialog_asignar_repartidor"
            max-width="900px"
            persistent
            scrollable
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Asignar Repartidor</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout row>
                            <v-flex
                                xs12
                                d-flex
                            >
                                <v-autocomplete
                                    v-model="repartidor_select"
                                    :items="repartidores"
                                    item-value="id"
                                    hide-no-data
                                    hide-selected
                                    chips
                                    deletable-chips
                                    label="Elegir Repartidor:"
                                    prepend-icon="mdi-database-search"
                                    return-object
                                    hint="Si dejas vacío el campo y das click en asignar, el pedido se guardará sin un vendedor/repartidor"
                                    persistent-hint

                                    @input="(payload) => repartidor_id = payload ? payload.id : ''"
                                >
                                    <template v-slot:selection="data">
                                        <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            close
                                            @click:close="repartidor_id = '';repartidor_select = null;"
                                        >
                                            <v-avatar left color="primary" dark>
                                                <span
                                                    class="white--text">{{ data.item.role_name.substring(0, 1) }}</span>
                                            </v-avatar>
                                            {{ data.item.nombre_completo }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                        <v-list-item-avatar color="primary">
                                            <span class="white--text">{{ data.item.role_name.substring(0, 1) }}</span>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.nombre_completo"></v-list-item-title>
                                            <v-list-item-subtitle v-html="data.item.role_name"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="gray darken-1"
                        @click="dialog_asignar_repartidor = false; repartidor_id = ''; repartidor_select = null;"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        class="white--text"
                        :loading="changing_repartidor"
                        :disabled="changing_repartidor"
                        @click="changeRepartidor()"
                    >
                        Asignar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import FormChangeStatus from "@components/FormChangeStatus";
import FormNotifyVendedor from "@components/FormNotifyVendedor";
import EventBus from "@/EventBus";
import SearchClientesInput from "@components/SearchClientesInput";
import SearchRepartidoresInput from "@components/SearchRepartidoresInput";
import SearchTagsInput from "@components/SearchTagsInput";
import FormSetTags from "@components/FormSetTags";

moment.locale('es');

export default {
    name: "PedidosPage",
    components: {
        FormChangeStatus,
        FormNotifyVendedor,
        SearchClientesInput,
        SearchRepartidoresInput,
        SearchTagsInput,
        FormSetTags,
    },
    data() {
        return {
            dialog_asignar_repartidor: false,
            pedido_id: null,
            changing_repartidor : false,
            repartidor_id: '',
            repartidor_select : null,
            repartidores: [],
            descending: true,
            sortBy: 'created_at',
            dialog: false,
            dialog_delete: false,
            dialog_change_status: false,
            dialog_notify_vendedor: false,
            dialog_set_tags: false,
            headers: [
                {
                    text: "Folio",
                    align: "left",
                    sortable: true,
                    value: "id",
                    width: "75px",
                },
                {
                    text: "Cliente",
                    align: "left",
                    sortable: false,
                    value: "user",
                },
                {
                    text: "Anónimo",
                    align: "left",
                    sortable: false,
                    value: "anonimo",
                },
                {
                    text: "Estatus",
                    align: "center",
                    sortable: false,
                    value: "estatus_id",
                },
                {
                    text: "Total",
                    align: "right",
                    sortable: false,
                    value: "total",
                },
                {
                    text: "Pago pendiente",
                    align: "right",
                    sortable: false,
                    value: "pago_pendiente",
                },
                {
                    text: "Fecha alta",
                    align: "center",
                    sortable: true,
                    value: "created_at",
                },
                {
                    text: "Actualizado",
                    align: "center",
                    sortable: true,
                    value: "updated_at",
                },
                {
                    text: "Recompensa",
                    align: "center",
                    sortable: true,
                    value: "recompensa_aplicada",
                },
                {
                    text: "Repartidor",
                    align: "center",
                    sortable: false,
                    value: "repartidor",
                },
                {
                    text: "Etiquetas",
                    align: "center",
                    sortable: false,
                    value: "tags",
                },
                {
                    text: "Opciones",
                    value: "actions",
                    sortable: false,
                    width: "200px",
                },
            ],
            pedidos: [],
            pedidosTotal: 0,
            itemSelectId: 0,
            itemDelete: null,
            loading: false,
            loading_cancelar: false,
            loading_estatus: false,
            options: {
                descending: true,
                page: 1,
                itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                totalItems: 0
            },
            pedido_select: null,
            filter: {
                desde: null,
                hasta: null,
                cuenta_id: null,
                anonimo: -1,
                estatus_id: 0,
                repartidor_id: "",
                folio: null,
                cliente_id: null,
                tag_id: null,
            },
            modal_desde: false,
            modal_hasta: false,
        };
    },
    computed: {
        estatus_list() {
            return [{value: 0, text: "Todos"}].concat(this.$root.estatus_all);
        },
        editItem() {
            if (this.itemSelectId) {
                return this.pedidos.find((item) => item.id === this.itemSelectId);
            } else {
                return {};
            }
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.initialize();
    },
    mounted() {
        this.listarStatus();
        this.listarRepartidores();
    },
    methods: {
        initialize() {
        },
        messageUrl(notificacion) {
            this.dialog_notify_vendedor = false;
            let texto = encodeURIComponent(notificacion.text);
            window.open(
                `https://api.whatsapp.com/send?phone=52${notificacion.phone}&text=${texto}`
            );
        },
        formatUpdateAt(fecha) {
            let fecha_moment = moment(fecha);

            return fecha_moment.fromNow();
        },
        close() {
            this.dialog = false;
            this.itemSelectId = 0;
        },
        editItemId(itemId) {
            this.itemSelectId = parseInt(itemId);
            this.dialog = true;
        },
        estatusCambiado(payload) {
            this.dialog_change_status = false;
            let pedidos = this.pedidos.map((item) => {
                if (item.id === payload.data.id) {
                    Object.assign(item, payload.data);
                }
                return item;
            });
            this.pedidos = pedidos;
        },
        etiquetasCambiadas(payload) {
            this.dialog_set_tags = false;
            let pedidos = this.pedidos.map((item) => {
                if (item.id === payload.data.id) {
                    Object.assign(item, payload.data);
                }
                return item;
            });
            this.pedidos = pedidos;
        },
        deleteItem() {
            this.loading_cancelar = true;
            axios
            .post("/api/pedidos/cancelar/" + this.itemDelete.id)
            .then((response) => {
                this.loading_cancelar = false;
                let {data} = response;
                if (data.success) {
                    EventBus.$emit("tugarrafon:show-snackbar", {
                        text_content: data.message,
                        color: "success",
                    });
                    this.itemDelete = null;
                    this.dialog_delete = false;
                    this.listar();
                }
            })
            .catch((error) => {
                this.loading_cancelar = false;
                if (error.response && error.response.data) {
                    EventBus.$emit("tugarrafon:show-snackbar", {
                        text_content: error.response.data.message,
                        color: "error",
                    });
                } else {
                    EventBus.$emit("tugarrafon:show-snackbar", {
                        text_content: "Error inesperado. Intenta nuevamente por favor...",
                        color: "error",
                    });
                }
            });
        },
        deleteItemConfirm(item) {
            this.itemDelete = item;
            this.dialog_delete = true;
        },
        listar() {
            this.loading = true;
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            axios
            .get("/api/pedidos/listar", {
                params: {
                    sortBy: sortBy,
                    sortDesc: sortDesc,
                    page: page,
                    rowsPerPage: itemsPerPage,
                    search: this.search,
                    ...this.filter,
                },
            })
            .then((success) => {
                this.loading = false;
                let {data} = success;
                this.pedidos = data.data;
                this.pedidosTotal = data.total;
                this.options.page = data.current_page;
            });
        },
        saveItem() {
            this.dialog = false;
            this.listar();
        },
        listarStatus() {
            // this.loading_estatus = true;
            // console.log("listar estatus");
            // axios.get('/api/pedidos/listar-estatus')
            //     .then(({data}) => {
            //         const fill = this.estatus_list.concat(data.data);
            //         this.estatus_list = Object.assign(fill);
            //         this.loading_estatus = false;
            //     })
        },
        asignarRepartidor({id}) {
            this.pedido_id = id;
            this.dialog_asignar_repartidor = true;
        },
        listarRepartidores() {
            axios.get("/api/usuarios/repartidores-listar").then(({data}) => {
                this.repartidores = data;
            })
        },
        changeRepartidor() {
            this.changing_repartidor = true;
            axios.post(`/api/pedidos/cambiar-repartidor/${this.pedido_id}`, {
                repartidor_id: this.repartidor_id
            }).then(({data}) => {
                this.$_showMessage(data.message);
                this.repartidor_id = "";
                this.repartidor_select = null;
                this.listar();
            }).finally(() => {
                this.changing_repartidor = false;
                this.dialog_asignar_repartidor = false;
            });
        }
    }
}
</script>

<style scoped>
</style>
